import { TableRow } from "@mui/material";
import React, { forwardRef, useState } from "react";
import styles from "./CustomTableRow.module.css";

const CustomTableRow = forwardRef(
	(
		{
			children,
			className = "",
			"data-testid": dataTestId = null,
			disabled = false,
			hover = false,
			hoverClassName = "",
			onClick = null,
			style = null,
			...rest
		},
		ref
	) => {
		const [isHovering, setIsHovering] = useState(false);
		const handleEnter = () => {
			setIsHovering(true);
		};
		const handleLeave = () => {
			setIsHovering(false);
		};
		const innerElements = typeof children === "function" ? children({ isHovering }) : children;
		return (
			<TableRow
				ref={ref}
				classes={{
					root: hoverClassName,
				}}
				className={`${(hover && styles.row) || ""} ${(onClick && styles["row--clickable"]) || ""} ${className}`}
				data-testid={dataTestId}
				style={{
					...style,
					...(disabled && { opacity: 0.5, pointerEvents: "none" }),
				}}
				onClick={onClick}
				onMouseEnter={handleEnter}
				onMouseLeave={handleLeave}
				{...rest}
			>
				{innerElements}
			</TableRow>
		);
	}
);

export default CustomTableRow;
